export function auxHeaderContent(options={}) {
    return `
    <div class="page_heading page_heading--aux_header">
        <h2 class="page_heading__title">${ options['name'] }</h2>
    </div>
    `;
}

export function auxHeaderLoadingContent(options={}) {
    return `
        <h3 class="online_app__aux__header__title">${ options['name'] }</h3>
    `;
}
